export const nav = {
  dashboard: 'Vezérlőpult',
  customers: 'Ügyfelek',
  customerGroups: 'Ügyfélcsoportok',
  leads: 'Lead-ek',
  documentStorage: 'Könyvtár',
  documentLibrary: 'Könyvtár',
  suppliers: 'Beszállítók',
  notes: 'Cetlik',
  richNotes: 'Jegyzetfüzet',
  appointments: 'Időpontfoglalás',
  customerPortal: 'Ügyfélportál',
  portalPreview: 'Portál előnézet',
  missingItems: 'Hiánylista',
  customerProjects: 'Ügyfél Ticketek',
  customerRelationshipLogs: 'Ügyfélkapcsolati napló',
  products: 'Termékek',
  categories: 'Kategóriák',
  webCategories: 'Webshop Kategóriák',
  productCategoryAssignment: 'Termékek kategorizálása',
  warehouse: 'Raktárak',
  inventory: 'Készlet',
  warranty: 'Garancia',
  offers: 'Árajánlatok',
  ai_quotations: 'AI Árajánlatok',
  deals: 'Ügyletek',
  contracts: 'Dokumentumok',
  worksheets: 'Munkalapok',
  reports: 'Jelentések',
  settings: 'Beállítások',
  profile: 'Profil',
  system_admin: 'Rendszergazda',
  storageOptimization: 'Storage Optimalizálás',
  templates: 'Sablonok',
  documentVariables: 'Változók',
  formBuilder: 'Űrlapok és Listák',
  formBuilderEditor: 'Form Builder',
  flowBuilder: 'Flow Builder',
  myForms: 'Saját Űrlapok',
  workPagesTemplates: 'Kitöltendő munkalap',
  filledWorkpage: 'Kitöltött munkalap',
  billing: 'Számlázás',
  billingSubtitle: 'Számlák, díjbekérők és jóváírások kezelése',
  subscriptions: 'Előfizetések',
  subscriptionsSubtitle: 'Előfizetések és fizetések kezelése',
  tasks: 'Feladatok',
  tasksSubtitle: 'Feladatok és teendők kezelése',
  projects: 'Projektek',
  projectsSubtitle: 'Projektek kezelése és nyomon követése',
  projectBoard: 'Projekt Board',
  projectReports: 'Projekt Riportok',
  projectReportsSubtitle: 'Projektek és feladatok elemzése',
  flowDebug: 'Flow Naplók',
  flowDebugSubtitle: 'Flow futási naplók és hibakeresés',
  pipeline: 'Pipeline',
  quotations: 'Árajánlatok',
  orders: 'Megrendelések',
  delivery_notes: 'Szállítólevelek',
  sales: 'Értékesítés',
  organization: 'Szervezet',
  selectOrganization: 'Válassz szervezetet',
  groups: {
    crm: 'CRM & Kapcsolatok',
    customerPortal: 'Ügyfélportál',
    products: 'Termékek & Készlet',
    sales: 'Értékesítés & Rendelések',
    documents: 'Dokumentumok',
    contracts: 'Szerződések',
    forms: 'Űrlapok',
    processes: 'Folyamatok',
    projects: 'Projektek & Feladatok',
    finance: 'Pénzügyek'
  },
  expandSidebar: 'Oldalsáv kibontása',
  collapseSidebar: 'Oldalsáv összecsukása'
}